module.exports = __webpack_public_path__ + "img/gshock_method_my.d7dcd198.png";